define.alias("shared/components/shared/ui/switcher/option", "preview-grid/components/shared/ui/switcher/option");